import * as React from 'react';
import { Button } from '@/components/ui/button';
import { report } from '@/shared/errorReporter';

interface Props {
  children: React.ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary', error, info);
    report(error, { componentStack: info.componentStack });
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 p-8 text-center">
          <h1 className="text-2xl font-bold">Что-то пошло не так</h1>
          <p className="text-sm text-muted-foreground max-w-md">{this.state.error.message}</p>
          <Button onClick={() => location.assign('/')}>На главную</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
